import React from 'react';
import { CheckCircle2 } from 'lucide-react';
const highlights = ['Decades of combined engineering experience', 'Cross-functional, senior-level talent', 'Agnostic technology approach tailored to your needs', 'Proven track record of successful enterprise deployments'];
export function WhoWeAre() {
  return <section className="py-20 lg:py-28 bg-background texture-light" data-id="element-178">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-179">
        <div className="scroll-fade-in-up" data-id="element-180">
          <h2 className="text-3xl md:text-4xl font-bold text-ink mb-6 text-center" data-id="element-181">
            Boutique Expertise.{' '}
            <span className="text-accent" data-id="element-182">Enterprise Scale.</span>
          </h2>
          <div className="space-y-6 text-lg text-muted" data-id="element-183">
            <p data-id="element-184">
              Magnus Software is a boutique custom software development firm
              specializing in complex, high-stakes engineering challenges. We
              don't just write code; we architect solutions that drive business
              transformation.
            </p>
            <p data-id="element-185">
              Our expertise spans across custom web applications, native mobile
              apps, embedded systems, high-availability databases, and AI
              automation. By maintaining a concentrated focus on engineering
              excellence, we deliver robust, secure, and scalable platforms that
              our clients rely on daily.
            </p>
            <ul className="space-y-3 mt-6" data-id="element-186">
              {highlights.map((item, index) => <li key={index} className="flex items-start gap-3" data-id="element-187">
                  <CheckCircle2 className="w-6 h-6 text-teal flex-shrink-0 mt-0.5" data-id="element-188" />
                  <span className="text-ink font-medium" data-id="element-189">{item}</span>
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}